export default __webpack_public_path__ + "static/media/empty-time-offs.a3e02d60.svg";